import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.href = "/#" + id;
  };

  const goArchives = () => navigate("/archives");

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
      <div className="container-hk py-16 md:py-24">
        {/* Massive brand */}
        <div className="font-display text-[18vw] md:text-[14vw] leading-[0.85] tracking-tighter uppercase">
          HAKAN<span className="text-[var(--hk-red)]">.</span>TIPS
        </div>
        <div className="mt-3 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="text-xs tracking-[0.3em] text-white/50 uppercase">
            {t.footer.tagline}
          </div>
          <a
            href="https://hakan-tips.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-banner-link"
            className="block shrink-0"
          >
            <img
              src="/hakan-tips-banner.gif"
              alt="HAKAN TIPS"
              data-testid="footer-banner-img"
              className="block w-full max-w-[728px] h-auto"
            />
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/10 pt-12">
          <div>
            <div className="text-[10px] tracking-[0.35em] text-white/40 mb-4">
              {t.footer.cols.product}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <button onClick={() => scrollTo("home")} data-testid="footer-home" className="hover:text-[var(--hk-red)] transition-colors">
                  {t.footer.links.home}
                </button>
              </li>
              <li>
                <button onClick={() => scrollTo("plans")} data-testid="footer-plans" className="hover:text-[var(--hk-red)] transition-colors">
                  {t.footer.links.plans}
                </button>
              </li>
              <li>
                <button onClick={goArchives} data-testid="footer-archive" className="hover:text-[var(--hk-red)] transition-colors">
                  {t.footer.links.archive}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.35em] text-white/40 mb-4">
              {t.footer.cols.legal}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/terms" data-testid="footer-terms" className="hover:text-[var(--hk-red)] transition-colors">
                  {t.footer.links.terms}
                </Link>
              </li>
              <li>
                <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[var(--hk-red)] transition-colors">
                  {t.footer.links.privacy}
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" data-testid="footer-disclaimer" className="hover:text-[var(--hk-red)] transition-colors">
                  {t.footer.links.disclaimer}
                </Link>
              </li>
              <li>
                <Link to="/cookies" data-testid="footer-cookies" className="hover:text-[var(--hk-red)] transition-colors">
                  {t.footer.links.cookies}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.35em] text-white/40 mb-4">
              {t.footer.cols.contact}
            </div>
            <ul className="space-y-3 text-sm">
              <li>Istanbul, Türkiye</li>
              <li>hakan@hakan-tips.com</li>
              <li>
                <button onClick={() => scrollTo("contact")} data-testid="footer-contact" className="hover:text-[var(--hk-red)] transition-colors underline underline-offset-4">
                  {t.footer.links.contact}
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/40">
          <div>© 2022 HAKAN TIPS. {t.footer.rights}</div>
          <div className="tracking-[0.2em] uppercase">www.hakan-tips.com</div>
        </div>
        <div className="mt-4 text-[11px] text-white/40 leading-relaxed">
          {t.footer.responsible}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
